import React from 'react';
import './ActivePeople.css';
import activeIcon from '../../icons/onlineIcon.png';
const ActivePeople = ({users}) => {
    console.log("Active ",users);

    return (
        <div className="textContainer">
            <div>
                <h1>ChatRoom<span role="img" aria-label="emoji">💬</span></h1>
                <h2>Developed By Sabbir Pulok<span role="img" aria-label="emoji">❤️</span></h2>
                <h3>Try it out right now! <span role="img" aria-label="emoji">⬅️</span></h3>
            </div> 
            {
                users &&
                (
                    <div>
                        <h1>Active Participants: </h1>
                        <div className="activeContainer">
                            <h2>
                                {users.map(({name})=>(
                                    <div key={name} className="activeItem">
                                        {name}
                                        <img src={activeIcon} alt="online"/>
                                    </div>
                                ))}
                            </h2>
                        </div>
                    </div>
                )
            }
        </div>
    );
};

export default ActivePeople;